import { render, staticRenderFns } from "./protected.vue?vue&type=template&id=44415aac"
import script from "./protected.vue?vue&type=script&lang=js"
export * from "./protected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports